import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { CallService } from './-call.service';

const API = `${environment.api}/api`;

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient, private callService: CallService) { }

  sendContact(info: any) {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();

    var tabData = {};
    tabData = {
      'nom': info.name,
      'prenom': info.firstName,
      "email": info.email,
      "adresse": info.address,
      "cp": info.postalCode,
      "ville": info.city,
      "message": info.message,
      'token': info.recaptchaToken
    };
    const body = tabData;

    return this.http.post(API + '/contact', body, httpOptions);
  }
}
